import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/views/pages/Home.vue';
import Index from '@/components/views/pages/Index.vue';
import AboutUs from '@/components/views/pages/AboutUs.vue';
import ContactUs from '@/components/views/pages/ContactUs.vue';
import Privacy from '@/components/views/pages/Privacy.vue';

// import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

// export default new Router({
//   routes: [
//     // {
//     //   path: '/',
//     //   name: 'HelloWorld',
//     //   component: HelloWorld
//     // }
//   ]
// })


const router = new Router({
  mode: 'history', // 去掉路径中的 # 号
  routes: [
    {
      path: '/',
      component: Home,
      children: [
        {
          path: '',
          name: 'Index',
          component: Index
        },
        {
          path: '/about',
          name: 'AboutUs',
          component: AboutUs
        },
        {
          path: '/contact',
          name: 'ContactUs',
          component: ContactUs
        },
        {
          path: '/privacy',
          name: 'Privacy',
          component: Privacy
        },

        
        // 其他子路由...
      ]
    }
    // 其他路由...
  ]
})


// 挂载路由导航守卫：to表示将要访问的路径，from表示从哪里来，next是下一个要做的操作
// router.beforeEach((to, from, next) => {
//   // 放行登录页面
//   if (to.path === '/login') {
//     return next()
//   }
//   // 获取token
//   const tokenStr = sessionStorage.getItem('token')
//   if (!tokenStr) {
//     return next('/login')
//   } else {
//     next()
//   }
// })

export default router


// WEBPACK FOOTER //
// ./src/router/index.js